import { action, makeObservable, observable } from 'mobx';

//  TODO: move packages features to this store
export class FeaturesStore {
  @observable public isCalendarIntegrationEnabled = false;
  @observable public isE2eeIntegrationEnabled = false;

  constructor() {
    makeObservable(this);
  }

  get isDemoChatTtlOptionsEnabled(): boolean {
    return PROJECT_CONFIG.features.isDemoChatTtlOptionsEnabled;
  }

  @action
  setIsCalendarIntegrationEnabled(isEnabled: boolean): void {
    this.isCalendarIntegrationEnabled = isEnabled;
  }

  @action
  setIsE2eeIntegrationEnabled(isEnabled: boolean): void {
    this.isE2eeIntegrationEnabled = isEnabled;
  }
}
